export default __webpack_public_path__ + "static/media/comp_name.aa07456c.svg";